import React, { useEffect } from "react";
import { useStores } from "../../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Stack } from "@chakra-ui/layout";
import { Input } from "@chakra-ui/input";
import { FormControl } from "@chakra-ui/form-control";
import {
  Flex,
  HStack,
  Table,
  Thead,
  Tr,
  Tbody,
  Th,
  Td,
} from "@chakra-ui/react";

import { Label } from "../../../components/Label";

export const TabSubscription: React.FC = observer(() => {
  const { clientsStore } = useStores();
  const { t } = useTranslation();

  useEffect(() => {
    if (clientsStore.customerData?.subscriptionID) {
      clientsStore.getStripeSubscription(
        clientsStore.customerData.subscriptionID
      );
    }
    if (clientsStore.customerData?.stripeID) {
      clientsStore.getPayments(clientsStore.customerData.stripeID);
    }
  }, [clientsStore.customerData]);

  return (
    <Flex mb={"20px"} direction="column">
      <HStack>
        <FormControl flexGrow={2}>
          <Label>{t("screens.client.subscription.subscription")}</Label>
          <Input
            size="lg"
            value={clientsStore.customerSubscription?.plan.productName}
            disabled
          />
        </FormControl>

        <FormControl>
          <Label>{t("screens.client.subscription.startDate")}</Label>
          <Input
            size="lg"
            value={clientsStore.customerSubscription?.start_date.toLocaleDateString()}
            disabled
          />
        </FormControl>

        <FormControl>
          <Label>{t("screens.client.subscription.endDate")}</Label>
          <Input
            size="lg"
            value={
              clientsStore.customerSubscription?.cancel_at
                ? clientsStore.customerSubscription?.cancel_at.toLocaleDateString()
                : "-"
            }
            disabled
          />
        </FormControl>
      </HStack>

      <Stack marginTop={"2rem"} overflowX="scroll">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>{t("screens.client.subscription.id")}</Th>
              <Th>{t("screens.client.subscription.amount")}</Th>
              <Th>{t("screens.client.subscription.currency")}</Th>
              <Th>{t("screens.client.subscription.created")}</Th>
              <Th>{t("screens.client.subscription.customer")}</Th>
              <Th>{t("screens.client.subscription.paid")}</Th>
              <Th>{t("screens.client.subscription.refunded")}</Th>
              <Th>{t("screens.client.subscription.status")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {!!clientsStore.customerPaymentsList ? (
              clientsStore.customerPaymentsList.map((payment) => {
                return (
                  <Tr>
                    <Th>{payment.id}</Th>
                    <Th>{payment.amount}</Th>
                    <Th>{payment.currency}</Th>
                    <Th>{payment.created.toLocaleString()}</Th>
                    <Th>{payment.customer}</Th>
                    <Th>{payment.paid}</Th>
                    <Th>{payment.refunded}</Th>
                    <Th>{payment.status}</Th>
                  </Tr>
                );
              })
            ) : (
              <Tr>
                <Td>Nessun pagamento</Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Stack>
    </Flex>
  );
});
